module.exports = __webpack_public_path__ + "static/media/400174_01.0f20d9af.png";